import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { SnackbarProvider } from 'notistack';
import theme from './theme';
import PrivateRoute from './components/PrivateRoute';
import AccessDeniedPage from './components/AccessDeniedPage';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import MenuModulos from './pages/MenuModulos';
import ModuloFuncionalidades from './pages/ModuloFuncionalidades';
import Productos from './pages/inventario/Productos';
import ProductoInfo360 from './pages/inventario/info360/ProductoInfo360';
import ProductoForm from './pages/inventario/ProductoForm';
import ImportacionPreciosProveedor from './pages/inventario/ImportacionPreciosProveedor';
import ImportacionPreciosArticulo from './pages/inventario/ImportacionPreciosArticulo';
import MantenimientoPreciosInventario from './pages/inventario/MantenimientoPreciosInventario';
import Descuentos from './pages/inventario/Descuentos';
import DescuentoForm from './pages/inventario/DescuentoForm';
import Transferencias from './pages/inventario/Transferencias';
import AjusteInventarioForm from './pages/inventario/AjusteInventarioForm';
import Ramos from './pages/inventario/Ramos';
import RamoForm from './pages/inventario/RamoForm';
import Lineas from './pages/inventario/Lineas';
import LineaForm from './pages/inventario/LineaForm';
import Clases from './pages/inventario/Clases';
import ClaseForm from './pages/inventario/ClaseForm';
import UnidadesMedida from './pages/inventario/UnidadesMedida';
import UnidadMedidaForm from './pages/inventario/UnidadMedidaForm';
import Devoluciones from './pages/inventario/Devoluciones';
import OrdenDevolucionForm from './pages/inventario/OrdenDevolucionForm';
import Picking from './pages/inventario/Picking';
import ConteoStock from './pages/inventario/ConteoStock';
import ProduccionModuleGate from './components/ProduccionModuleGate';
import FashionModuleGate from './components/FashionModuleGate';
import Recetas from './pages/produccion/Recetas';
import RecetaForm from './pages/produccion/RecetaForm';
import OrdenesProduccion from './pages/produccion/OrdenesProduccion';
import OrdenProduccionForm from './pages/produccion/OrdenProduccionForm';
import ConfirmarProduccion from './pages/produccion/ConfirmarProduccion';
import DesviosConsumoProduccion from './pages/produccion/DesviosConsumoProduccion';
import Colores from './pages/inventario/fashion/Colores';
import ColorForm from './pages/inventario/fashion/ColorForm';
import CurvasTalle from './pages/inventario/fashion/CurvasTalle';
import CurvaTalleForm from './pages/inventario/fashion/CurvaTalleForm';
import Temporadas from './pages/inventario/fashion/Temporadas';
import TemporadaForm from './pages/inventario/fashion/TemporadaForm';
import Modelos from './pages/inventario/fashion/Modelos';
import ModeloForm from './pages/inventario/fashion/ModeloForm';
import CurvaTallesInforme from './pages/inventario/fashion/CurvaTallesInforme';
import ConteoStockForm from './pages/inventario/ConteoStockForm';
import Recibos from './components/Tesoreria/Recibos';
import NuevoRecibo from './components/Tesoreria/NuevoRecibo';
import DevolucionesTesoreria from './components/Tesoreria/Devoluciones';
import NuevaDevolucion from './components/Tesoreria/NuevaDevolucion';
import OrdenPago from './components/Tesoreria/OrdenPago';
import NuevaOrdenPago from './components/Tesoreria/NuevaOrdenPago';
import OrdenPagoDetalle from './pages/tesoreria/OrdenPagoDetalle';
import MovimientosVarios from './components/Tesoreria/MovimientosVarios';
import MovimientosBancarios from './components/Tesoreria/MovimientosBancarios';
import ConciliacionBancaria from './components/Tesoreria/ConciliacionBancaria';
import NuevoMovimientoCaja from './components/Tesoreria/NuevoMovimientoCaja';
import Bancos from './pages/tesoreria/Bancos';
import BancoForm from './pages/tesoreria/BancoForm';
import Carteras from './pages/tesoreria/Carteras';
import CarteraForm from './pages/tesoreria/CarteraForm';
import GruposMcp from './pages/tesoreria/GruposMcp';
import GrupoMcpForm from './pages/tesoreria/GrupoMcpForm';
import Mcps from './pages/tesoreria/Mcps';
import McpForm from './pages/tesoreria/McpForm';
import MarcasTarjetas from './pages/tesoreria/MarcasTarjetas';
import MarcaTarjetaForm from './pages/tesoreria/MarcaTarjetaForm';
import MovimientosCaja from './pages/tesoreria/MovimientosCaja';
import TesoreriaInformes from './pages/tesoreria/Informes';
import ChequesTercero from './pages/tesoreria/ChequesTercero';
import ChequesTercerosCartera from './pages/tesoreria/ChequesTercerosCartera';
import ChequesPropios from './pages/tesoreria/ChequesPropios';
import ChequesPropiosPendientesAcreditar from './pages/tesoreria/ChequesPropiosPendientesAcreditar';
import Disponibilidades from './pages/tesoreria/Disponibilidades';
import MovimientosCarteras from './pages/tesoreria/MovimientosCarteras';
import FlujoFondosPage from './pages/tesoreria/FlujoFondosPage';
import TesoreriaTransferencias from './pages/tesoreria/Transferencias';
import ConsultaIaModuloPage from './pages/ConsultaIaModuloPage';
import StockPorDeposito from './pages/inventario/StockPorDeposito';
import StockAFecha from './pages/inventario/StockAFecha';
import StockInmovilizado from './pages/inventario/StockInmovilizado';
import Informes from './pages/inventario/Informes';
import MovimientosStock from './pages/inventario/MovimientosStock';
import LotesPage from './pages/inventario/LotesPage';
import LoteDetallePage from './pages/inventario/LoteDetallePage';
import LotesMovimientosInforme from './pages/inventario/LotesMovimientosInforme';
import LotesSaldosInforme from './pages/inventario/LotesSaldosInforme';
import LotesTrazabilidadInforme from './pages/inventario/LotesTrazabilidadInforme';
import LotesVencimientosInforme from './pages/inventario/LotesVencimientosInforme';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import ClienteInfo360 from './pages/clientes/info360/ClienteInfo360';
import StoreB2bAccessRequestsPage from './pages/StoreB2bAccessRequestsPage';
import Proveedores from './pages/compras/Proveedores';
import ProveedorForm from './pages/compras/ProveedorForm';
import Pedidos from './pages/pedidoventa/Pedidos';
import PedidosVenta from './pages/pedidoventa/index';
import PedidoVentaAltaRedirect from './pages/pedidoventa/PedidoVentaAltaRedirect';
import Cotizaciones from './pages/cotizacionventa/Cotizaciones';
import CotizacionesVenta from './pages/cotizacionventa/index';
import CotizacionVentaAltaRedirect from './pages/cotizacionventa/CotizacionVentaAltaRedirect';
import NuevaFacturaPOS from './pages/facturaventa/NuevaFacturaPOS';
import NuevaFacturaVenta from './pages/facturaventa/index';
import FacturaVentaVerRedirect from './pages/facturaventa/FacturaVentaVerRedirect';
import FacturaVentaEditarRedirect from './pages/facturaventa/FacturaVentaEditarRedirect';
import VentasInformes from './pages/ventas/Informes';
import CuentasPorCobrar from './pages/ventas/CuentasPorCobrar';
import ResumenCuentaVentas from './pages/ventas/ResumenCuenta';
import Facturas from './pages/ventas/Facturas';
import Remitos from './pages/ventas/Remitos';
import RemitoVentaForm from './pages/ventas/RemitoVentaForm';
import NotasCredito from './pages/ventas/NotasCredito';
import NotaCreditoVentaDetalle from './pages/ventas/NotaCreditoVentaDetalle';
import NotasDebito from './pages/ventas/NotasDebito';
import NotaCreditoVentaAltaRedirect from './pages/ventas/NotaCreditoVentaAltaRedirect';
import NotaDebitoVentaAltaRedirect from './pages/ventas/NotaDebitoVentaAltaRedirect';
import NotaDebitoVentaDetalle from './pages/ventas/NotaDebitoVentaDetalle';
import NuevaNotaCreditoPOS from './pages/notacreditoventa/NuevaNotaCreditoPOS';
import NuevaNotaDebitoPOS from './pages/notadebitoventa/NuevaNotaDebitoPOS';
import LibroIvaVentas from './pages/ventas/LibroIvaVentas';
import SeguimientoVentas from './pages/ventas/SeguimientoVentas';
import InformeVentasDinamico from './pages/ventas/InformeVentasDinamico';
import InformeVentasResumenProducto from './pages/ventas/InformeVentasResumenProducto';
import InformeVentasResultados from './pages/ventas/InformeVentasResultados';
import InformesPersonalizados from './pages/ventas/InformesPersonalizados';
import ComprasInformes from './pages/compras/Informes';
import CuentasPorPagar from './pages/compras/CuentasPorPagar';
import ResumenCuenta from './pages/compras/ResumenCuenta';
import LibroIvaCompras from './pages/compras/LibroIvaCompras';
import InformeComprasDinamico from './pages/compras/InformeComprasDinamico';
import SeguimientoCompras from './pages/compras/SeguimientoCompras';
import SugerenciaCompra from './pages/compras/SugerenciaCompra';
import SugerenciaCompraPreview from './pages/compras/SugerenciaCompraPreview';
import FacturasCompra from './pages/compras/FacturasCompra';
import FacturaCompraForm from './pages/compras/FacturaCompraForm';
import FacturaCompraDetalle from './pages/compras/FacturaCompraDetalle';
import NotasCreditoCompra from './pages/compras/NotasCreditoCompra';
import NotaCreditoCompraForm from './pages/compras/NotaCreditoCompraForm';
import NotaCreditoCompraDetalle from './pages/compras/NotaCreditoCompraDetalle';
import RemitosCompra from './pages/compras/RemitosCompra';
import RemitoCompraForm from './pages/compras/RemitoCompraForm';
import RemitoCompraDetalle from './pages/compras/RemitoCompraDetalle';
import OrdenesCompra from './pages/compras/OrdenesCompra';
import OrdenCompraForm from './pages/compras/OrdenCompraForm';
import OrdenCompraDetalle from './pages/compras/OrdenCompraDetalle';
import Usuarios from './pages/sistema/Usuarios';
import UsuarioForm from './pages/sistema/UsuarioForm';
import TipoFormulario from './pages/sistema/TipoFormulario';
import TipoFormularioForm from './pages/sistema/TipoFormularioForm';
import Provincias from './pages/sistema/Provincias';
import ProvinciaForm from './pages/sistema/ProvinciaForm';
import Localidades from './pages/sistema/Localidades';
import LocalidadForm from './pages/sistema/LocalidadForm';
import MovMoneda from './pages/sistema/MovMoneda';
import MovMonedaForm from './pages/sistema/MovMonedaForm';
import Monedas from './pages/sistema/Monedas';
import MonedaForm from './pages/sistema/MonedaForm';
import Companias from './pages/sistema/Companias';
import CompaniaForm from './pages/sistema/CompaniaForm';
import CertificadosArca from './pages/sistema/CertificadosArca';
import WsfeTipComp from './pages/sistema/WsfeTipComp';
import Tenants from './pages/sistema/Tenants';
import TenantForm from './pages/sistema/TenantForm';
import TenantCloneForm from './pages/sistema/TenantCloneForm';
import TenantDataCleanup from './pages/sistema/TenantDataCleanup';
import MasterUsers from './pages/sistema/MasterUsers';
import MasterUserForm from './pages/sistema/MasterUserForm';
import TenantAdminGate from './components/sistema/TenantAdminGate';
import BibliotecaInformes from './pages/sistema/BibliotecaInformes';
import BibliotecaInformeDetalle from './pages/sistema/BibliotecaInformeDetalle';
import ServicioModuleGate from './components/ServicioModuleGate';
import CrmModuleGate from './components/CrmModuleGate';
import Tecnicos from './pages/servicio/Tecnicos';
import TecnicoForm from './pages/servicio/TecnicoForm';
import Vehiculos from './pages/servicio/Vehiculos';
import VehiculoForm from './pages/servicio/VehiculoForm';
import Turnos from './pages/servicio/Turnos';
import TurnoForm from './pages/servicio/TurnoForm';
import OrganizadorServicios from './pages/servicio/OrganizadorServicios';
import OrdenesReparacion from './pages/servicio/OrdenesReparacion';
import OrdenReparacionForm from './pages/servicio/OrdenReparacionForm';
import CajaxUsuario from './pages/sistema/CajaxUsuario';
import CajaUsuarioForm from './pages/sistema/CajaUsuarioForm';
import GrupoMcpUsuarioPage from './pages/sistema/GrupoMcpUsuario';
import GrupoMcpUsuarioForm from './pages/sistema/GrupoMcpUsuarioForm';
import Vendedores from './pages/ventas/Vendedores';
import VendedorForm from './pages/ventas/VendedorForm';
import LiquidacionComisiones from './pages/ventas/LiquidacionComisiones';
import LiquidacionesComisiones from './pages/ventas/LiquidacionesComisiones';
import Rutas from './pages/ventas/Rutas';
import RutaForm from './pages/ventas/RutaForm';
import ListaPrecios from './pages/ventas/ListaPrecios';
import ListaPrecioForm from './pages/ventas/ListaPrecioForm';
import ArticuloXListaPrecio from './pages/ventas/ArticuloXListaPrecio';
import ArticuloXListaPrecioForm from './pages/ventas/ArticuloXListaPrecioForm';
import Visitas from './pages/ventas/Visitas';
import CrmContactos from './pages/crm/CrmContactos';
import CrmContactoForm from './pages/crm/CrmContactoForm';
import CrmEmpresas from './pages/crm/CrmEmpresas';
import CrmEmpresaForm from './pages/crm/CrmEmpresaForm';
import CrmPipelineKanban from './pages/crm/CrmPipelineKanban';
import CrmOportunidadDetalle from './pages/crm/CrmOportunidadDetalle';
import CrmKpis from './pages/crm/CrmKpis';
import CrmAgenda from './pages/crm/CrmAgenda';
import CrmConfig from './pages/crm/CrmConfig';
import RamosProv from './pages/compras/RamosProv';
import RamosProvForm from './pages/compras/RamosProvForm';
import Transportes from './pages/configuraciones/Transportes';
import TransporteForm from './pages/configuraciones/TransporteForm';
import Impuestos from './pages/configuraciones/Impuestos';
import ImpuestoForm from './pages/configuraciones/ImpuestoForm';
import Ubicaciones from './pages/configuraciones/Ubicaciones';
import UbicacionForm from './pages/configuraciones/UbicacionForm';
import SucVenta from './pages/configuraciones/SucVenta';
import SucVentaForm from './pages/configuraciones/SucVentaForm';
import SucursalesVenta from './pages/configuraciones/SucursalesVenta';
import SucursalVentaForm from './pages/configuraciones/SucursalVentaForm';
import IntegrationAccessTokens from './pages/configuraciones/IntegrationAccessTokens';
import AgentAccessTokens from './pages/configuraciones/AgentAccessTokens';
import Webhooks from './pages/configuraciones/Webhooks';
import WebhooksDocumentacion from './pages/configuraciones/WebhooksDocumentacion';
import CorreoSalida from './pages/configuraciones/CorreoSalida';
import ConfiguracionTienda from './pages/configuraciones/ConfiguracionTienda';
import ConfiguracionesHub from './pages/configuraciones/ConfiguracionesHub';
import ParametrosSistema from './pages/configuraciones/ParametrosSistema';
import ParametroSistemaForm from './pages/configuraciones/ParametroSistemaForm';
import VariablesSistema from './pages/configuraciones/VariablesSistema';
import VariablesSistemaForm from './pages/configuraciones/VariablesSistemaForm';
import Imputables from './pages/contabilidad/Imputables';
import ImputableForm from './pages/contabilidad/ImputableForm';
import NoImputables from './pages/contabilidad/NoImputables';
import NoImputableForm from './pages/contabilidad/NoImputableForm';
import PlanCuentas from './pages/contabilidad/PlanCuentas';
import Estrategia from './pages/contabilidad/Estrategia';
import EstrategiaForm from './pages/contabilidad/EstrategiaForm';
import AsientosDiario from './pages/contabilidad/AsientosDiario';
import AsientoDiarioForm from './pages/contabilidad/AsientoDiarioForm';
import LibroMayor from './pages/contabilidad/LibroMayor';
import EstadoResultados from './pages/contabilidad/EstadoResultados';
import SituacionPatrimonial from './pages/contabilidad/SituacionPatrimonial';
import ContabilidadInformes from './pages/contabilidad/ContabilidadInformes';

import PwaInstallPrompt from './components/PwaInstallPrompt';
import AppUpdatePrompt from './components/AppUpdatePrompt';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { APP_UPDATE_PENDING_CHECK_KEY, APP_VERSION_CHECK_PENDING_EVENT } from './constants/pwaInstallPrompt';

const App: React.FC = () => {
    useEffect(() => {
      if (process.env.NODE_ENV === 'development') {
        serviceWorkerRegistration.unregister();
        return;
      }

      serviceWorkerRegistration.register({
        onUpdate: () => {
          sessionStorage.setItem(APP_UPDATE_PENDING_CHECK_KEY, '1');
          window.dispatchEvent(new Event(APP_VERSION_CHECK_PENDING_EVENT));
        },
        onSuccess: () => {
          console.log('Service Worker registrado correctamente');
        },
      });
    }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        dense
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <AuthProvider>
          <PermissionProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/"
                element={
                  // PrivateRoute: auth. AuthorizedRoute (en Layout): permisos por ruta.
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/menu-principal" replace />} />
                <Route path="acceso-denegado" element={<AccessDeniedPage />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="menu-principal" element={<MenuModulos />} />
                <Route path="tesoreria">
                  <Route index element={<ModuloFuncionalidades moduloPath="/tesoreria" cardScale={0.75} />} />
                  <Route path="recibos" element={<Recibos />} />
                  <Route path="recibos/nuevo" element={<NuevoRecibo />} />
                  <Route path="devoluciones" element={<DevolucionesTesoreria />} />
                  <Route path="devoluciones/nuevo" element={<NuevaDevolucion />} />
                  <Route path="orden-pago" element={<OrdenPago />} />
                  <Route path="orden-pago/nuevo" element={<NuevaOrdenPago />} />
                  <Route path="orden-pago/:nroFormulario" element={<OrdenPagoDetalle />} />
                  <Route path="movimientos-varios" element={<MovimientosVarios />} />
                  <Route path="movimientos-varios/nuevo" element={<NuevoMovimientoCaja />} />
                  <Route path="movimientos-bancarios" element={<MovimientosBancarios />} />
                  <Route path="movimientos-bancarios/nuevo" element={<NuevoMovimientoCaja />} />
                  <Route path="conciliacion-bancaria" element={<ConciliacionBancaria />} />
                  <Route path="bancos" element={<Bancos />} />
                  <Route path="bancos/nuevo" element={<BancoForm />} />
                  <Route path="bancos/:nroBanco" element={<BancoForm />} />
                  <Route path="carteras" element={<Carteras />} />
                  <Route path="carteras/nuevo" element={<CarteraForm />} />
                  <Route path="carteras/:nroBanco" element={<CarteraForm />} />
                  <Route path="grupos-mcp" element={<GruposMcp />} />
                  <Route path="grupos-mcp/nuevo" element={<GrupoMcpForm />} />
                  <Route path="grupos-mcp/:grupoMcp" element={<GrupoMcpForm />} />
                  <Route path="medios-mcp" element={<Mcps />} />
                  <Route path="medios-mcp/nuevo" element={<McpForm />} />
                  <Route path="medios-mcp/:mcp/:tipo" element={<McpForm />} />
                  <Route path="tarjetas" element={<MarcasTarjetas />} />
                  <Route path="tarjetas/nuevo" element={<MarcaTarjetaForm />} />
                  <Route path="tarjetas/:codigoMarca" element={<MarcaTarjetaForm />} />
                  <Route path="movimientos-caja" element={<MovimientosCaja />} />
                  <Route path="disponibilidades" element={<Disponibilidades />} />
                  <Route path="transferencias" element={<TesoreriaTransferencias />} />
                  <Route path="informes" element={<TesoreriaInformes />} />
                  <Route path="informes/flujo-fondos" element={<FlujoFondosPage />} />
                  <Route path="informes/personalizados" element={<InformesPersonalizados />} />
                  <Route path="informes/cheques-tercero" element={<ChequesTercero />} />
                  <Route path="informes/cheques-terceros-cartera" element={<ChequesTercerosCartera />} />
                  <Route path="informes/cheques-propios" element={<ChequesPropios />} />
                  <Route path="informes/cheques-propios-pendientes-acreditar" element={<ChequesPropiosPendientesAcreditar />} />
                  <Route path="informes/movimientos-carteras" element={<MovimientosCarteras />} />
                  <Route path="consultas-ia" element={<ConsultaIaModuloPage modulo="tesoreria" />} />
                </Route>
                <Route path="inventario">
                  <Route index element={<ModuloFuncionalidades moduloPath="/inventario" cardScale={0.75} />} />
                  <Route path="mantenimiento-precios" element={<MantenimientoPreciosInventario />} />
                  <Route path="descuentos" element={<Descuentos />} />
                  <Route path="descuentos/nuevo" element={<DescuentoForm />} />
                  <Route path="descuentos/editar" element={<DescuentoForm />} />
                  <Route path="productos" element={<Productos />} />
                  <Route path="productos/nuevo" element={<ProductoForm />} />
                  <Route path="productos/:codigoArticulo/info" element={<ProductoInfo360 />} />
                  <Route path="productos/:codigoArticulo" element={<ProductoForm />} />
                  <Route
                    path="importacion-precios-proveedor"
                    element={<Navigate to="/inventario/importacion-costos-proveedor" replace />}
                  />
                  <Route path="importacion-costos-proveedor" element={<ImportacionPreciosProveedor />} />
                  <Route
                    path="importacion-precios-articulo"
                    element={<Navigate to="/inventario/importacion-costos-articulo" replace />}
                  />
                  <Route path="importacion-costos-articulo" element={<ImportacionPreciosArticulo />} />
                  <Route path="transferencias" element={<Transferencias />} />
                  <Route path="transferencias/nuevo" element={<AjusteInventarioForm />} />
                  <Route path="transferencias/:nroFormulario" element={<AjusteInventarioForm />} />
                  <Route path="ramos" element={<Ramos />} />
                  <Route path="ramos/nuevo" element={<RamoForm />} />
                  <Route path="ramos/:codigoRamo" element={<RamoForm />} />
                  <Route path="lineas" element={<Lineas />} />
                  <Route path="lineas/nuevo" element={<LineaForm />} />
                  <Route path="lineas/:codigoLinea" element={<LineaForm />} />
                  <Route path="clases" element={<Clases />} />
                  <Route path="clases/nuevo" element={<ClaseForm />} />
                  <Route path="clases/:codigoClase" element={<ClaseForm />} />
                  <Route path="unidades-medida" element={<UnidadesMedida />} />
                  <Route path="unidades-medida/nuevo" element={<UnidadMedidaForm />} />
                  <Route path="unidades-medida/:idUnidadMedida" element={<UnidadMedidaForm />} />
                  <Route path="devoluciones" element={<Navigate to="/ventas/ordenes-devolucion" replace />} />
                  <Route path="devoluciones/nuevo" element={<Navigate to="/ventas/ordenes-devolucion/nuevo" replace />} />
                  <Route path="produccion" element={<Navigate to="/produccion/ordenes" replace />} />
                  <Route path="picking" element={<Picking />} />
                  <Route path="conteo" element={<ConteoStock />} />
                  <Route path="conteo/nuevo" element={<ConteoStockForm />} />
                  <Route path="conteo/:nroFormulario" element={<ConteoStockForm />} />
                  <Route path="lotes" element={<LotesPage />} />
                  <Route path="lotes/:idLote" element={<LoteDetallePage />} />
                  <Route path="informes" element={<Informes />} />
                  <Route path="informes/personalizados" element={<InformesPersonalizados />} />
                  <Route path="informes/stock-deposito" element={<StockPorDeposito />} />
                  <Route path="informes/stock-a-fecha" element={<StockAFecha />} />
                  <Route path="informes/stock-inmovilizado" element={<StockInmovilizado />} />
                  <Route path="informes/movimientos-stock" element={<MovimientosStock />} />
                  <Route path="informes/curva-talles" element={<CurvaTallesInforme />} />
                  <Route path="informes/lotes-movimientos" element={<LotesMovimientosInforme />} />
                  <Route path="informes/lotes-saldos" element={<LotesSaldosInforme />} />
                  <Route path="informes/lotes-trazabilidad" element={<LotesTrazabilidadInforme />} />
                  <Route path="informes/lotes-vencimientos" element={<LotesVencimientosInforme />} />
                  <Route path="fashion">
                    <Route
                      index
                      element={
                        <FashionModuleGate>
                          <ModuloFuncionalidades
                            moduloPath="/inventario/fashion"
                            cardScale={0.75}
                          />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="modelos"
                      element={
                        <FashionModuleGate>
                          <Modelos />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="modelos/nuevo"
                      element={
                        <FashionModuleGate>
                          <ModeloForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="modelos/:codigoModelo"
                      element={
                        <FashionModuleGate>
                          <ModeloForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="colores"
                      element={
                        <FashionModuleGate>
                          <Colores />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="colores/nuevo"
                      element={
                        <FashionModuleGate>
                          <ColorForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="colores/:codigoColor"
                      element={
                        <FashionModuleGate>
                          <ColorForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="curvas-talle"
                      element={
                        <FashionModuleGate>
                          <CurvasTalle />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="curvas-talle/nuevo"
                      element={
                        <FashionModuleGate>
                          <CurvaTalleForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="curvas-talle/:codigoCurva"
                      element={
                        <FashionModuleGate>
                          <CurvaTalleForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="temporadas"
                      element={
                        <FashionModuleGate>
                          <Temporadas />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="temporadas/nuevo"
                      element={
                        <FashionModuleGate>
                          <TemporadaForm />
                        </FashionModuleGate>
                      }
                    />
                    <Route
                      path="temporadas/:codigoTemporada"
                      element={
                        <FashionModuleGate>
                          <TemporadaForm />
                        </FashionModuleGate>
                      }
                    />
                  </Route>
                  <Route path="consultas-ia" element={<ConsultaIaModuloPage modulo="inventario" />} />
                </Route>
                <Route path="compras">
                  <Route index element={<ModuloFuncionalidades moduloPath="/compras" cardScale={0.75} />} />
                  <Route path="facturas" element={<FacturasCompra />} />
                  <Route path="facturas/nuevo" element={<FacturaCompraForm />} />
                  <Route path="facturas/:nroFormulario" element={<FacturaCompraDetalle />} />
                  <Route path="notas-credito" element={<NotasCreditoCompra />} />
                  <Route path="notas-credito/nuevo" element={<NotaCreditoCompraForm />} />
                  <Route path="notas-credito/:nroFormulario" element={<NotaCreditoCompraDetalle />} />
                  <Route path="ordenes" element={<OrdenesCompra />} />
                  <Route path="ordenes/nuevo" element={<OrdenCompraForm />} />
                  <Route path="ordenes/:nroFormulario" element={<OrdenCompraDetalle />} />
                  <Route path="remitos/nuevo" element={<RemitoCompraForm />} />
                  <Route path="remitos/:nroFormulario" element={<RemitoCompraDetalle />} />
                  <Route path="remitos" element={<RemitosCompra />} />
                  <Route path="proveedores" element={<Proveedores />} />
                  <Route path="proveedores/nuevo" element={<ProveedorForm />} />
                  <Route path="proveedores/:nroProveedor" element={<ProveedorForm />} />
                  <Route path="ramosprov" element={<RamosProv />} />
                  <Route path="ramosprov/nuevo" element={<RamosProvForm />} />
                  <Route path="ramosprov/:codigoRamoProv" element={<RamosProvForm />} />
                  <Route path="informes" element={<ComprasInformes />} />
                  <Route path="informes/personalizados" element={<InformesPersonalizados />} />
                  <Route path="informes/cuentas-pagar" element={<CuentasPorPagar />} />
                  <Route path="informes/resumen-cuenta" element={<ResumenCuenta />} />
                  <Route path="informes/resumen-cuenta/:nroProveedor" element={<ResumenCuenta />} />
                  <Route path="informes/libro-iva-compras" element={<LibroIvaCompras />} />
                  <Route path="informes/compras-dinamico" element={<InformeComprasDinamico />} />
                  <Route path="informes/seguimiento-compras" element={<SeguimientoCompras />} />
                  <Route path="informes/sugerencia-compra" element={<SugerenciaCompra />} />
                  <Route path="informes/sugerencia-compra/preview" element={<SugerenciaCompraPreview />} />
                  <Route path="consultas-ia" element={<ConsultaIaModuloPage modulo="compras" />} />
                </Route>
                <Route path="crm">
                  <Route
                    index
                    element={
                      <CrmModuleGate>
                        <ModuloFuncionalidades moduloPath="/crm" cardScale={0.75} />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="contactos"
                    element={
                      <CrmModuleGate>
                        <CrmContactos />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="contactos/nuevo"
                    element={
                      <CrmModuleGate>
                        <CrmContactoForm />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="contactos/:id"
                    element={
                      <CrmModuleGate>
                        <CrmContactoForm />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="empresas"
                    element={
                      <CrmModuleGate>
                        <CrmEmpresas />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="empresas/nuevo"
                    element={
                      <CrmModuleGate>
                        <CrmEmpresaForm />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="empresas/:id"
                    element={
                      <CrmModuleGate>
                        <CrmEmpresaForm />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="pipeline"
                    element={
                      <CrmModuleGate>
                        <CrmPipelineKanban />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="oportunidades/:id"
                    element={
                      <CrmModuleGate>
                        <CrmOportunidadDetalle />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="agenda"
                    element={
                      <CrmModuleGate>
                        <CrmAgenda />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="kpis"
                    element={
                      <CrmModuleGate>
                        <CrmKpis />
                      </CrmModuleGate>
                    }
                  />
                  <Route
                    path="config"
                    element={
                      <CrmModuleGate>
                        <CrmConfig />
                      </CrmModuleGate>
                    }
                  />
                </Route>
                <Route path="ventas">
                  <Route index element={<ModuloFuncionalidades moduloPath="/ventas" cardScale={0.75} />} />
                  <Route path="clientes" element={<Clientes />} />
                  <Route path="clientes/nuevo" element={<ClienteForm />} />
                  <Route path="clientes/solicitudes-ecommerce" element={<StoreB2bAccessRequestsPage />} />
                  <Route path="clientes/:nroCliente/info" element={<ClienteInfo360 />} />
                  <Route path="clientes/:nroCliente" element={<ClienteForm />} />
                  <Route path="pedidos" element={<Pedidos />} />
                  <Route path="pedidos/nuevo" element={<PedidoVentaAltaRedirect />} />
                  <Route path="pedidos/nuevo-pos" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/editar" element={<PedidosVenta />} />
                  <Route path="pedidos/:pedidoId/ver" element={<PedidosVenta />} />
                  <Route path="cotizaciones" element={<Cotizaciones />} />
                  <Route path="cotizaciones/nuevo" element={<CotizacionVentaAltaRedirect />} />
                  <Route path="cotizaciones/nuevo-pos" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/editar" element={<CotizacionesVenta />} />
                  <Route path="cotizaciones/:cotizacionId/ver" element={<CotizacionesVenta />} />
                  <Route path="facturas" element={<Facturas />} />
                  <Route path="remitos" element={<Remitos />} />
                  <Route path="remitos/nuevo" element={<RemitoVentaForm />} />
                  <Route path="ordenes-devolucion" element={<Devoluciones />} />
                  <Route path="ordenes-devolucion/nuevo" element={<OrdenDevolucionForm />} />
                  <Route path="facturas/nuevo" element={<NuevaFacturaVenta />} />
                  <Route path="facturas/clasico" element={<NuevaFacturaVenta />} />
                  <Route path="facturas/pos" element={<NuevaFacturaPOS />} />
                  <Route path="facturas/:nroFormulario/ver" element={<FacturaVentaVerRedirect />} />
                  <Route path="facturas/:nroFormulario/editar" element={<FacturaVentaEditarRedirect />} />
                  <Route path="notas-credito" element={<NotasCredito />} />
                  <Route path="notas-credito/nuevo" element={<NotaCreditoVentaAltaRedirect />} />
                  <Route path="notas-credito/nuevo-pos" element={<NuevaNotaCreditoPOS />} />
                  <Route path="notas-credito/:nroFormulario" element={<NotaCreditoVentaDetalle />} />
                  <Route path="notas-debito" element={<NotasDebito />} />
                  <Route path="notas-debito/nuevo" element={<NotaDebitoVentaAltaRedirect />} />
                  <Route path="notas-debito/nuevo-pos" element={<NuevaNotaDebitoPOS />} />
                  <Route path="notas-debito/:nroFormulario" element={<NotaDebitoVentaDetalle />} />
                  <Route path="visitas" element={<Visitas />} />
                  <Route path="liquidacion-comisiones" element={<LiquidacionesComisiones />} />
                  <Route path="liquidacion-comisiones/nuevo" element={<LiquidacionComisiones />} />
                  <Route path="vendedores" element={<Vendedores />} />
                  <Route path="vendedores/nuevo" element={<VendedorForm />} />
                  <Route path="vendedores/:codigoVendedor" element={<VendedorForm />} />
                  <Route path="rutas" element={<Rutas />} />
                  <Route path="rutas/nuevo" element={<RutaForm />} />
                  <Route path="rutas/:codigoRuta" element={<RutaForm />} />
                  <Route path="listaprecios" element={<ListaPrecios />} />
                  <Route path="listaprecios/nuevo" element={<ListaPrecioForm />} />
                  <Route path="listaprecios/:codigoLista" element={<ListaPrecioForm />} />
                  <Route path="lista-precios" element={<ListaPrecios />} />
                  <Route path="lista-precios/nuevo" element={<ListaPrecioForm />} />
                  <Route path="lista-precios/:codigoLista" element={<ListaPrecioForm />} />
                  <Route path="articuloxlistaprecio" element={<ArticuloXListaPrecio />} />
                  <Route path="articuloxlistaprecio/nuevo" element={<ArticuloXListaPrecioForm />} />
                  <Route path="articuloxlistaprecio/:nroLista/:codigoArticulo" element={<ArticuloXListaPrecioForm />} />
                  <Route path="informes" element={<VentasInformes />} />
                  <Route path="informes/seguimiento-ventas" element={<SeguimientoVentas />} />
                  <Route path="informes/cuentas-cobrar" element={<CuentasPorCobrar />} />
                  <Route path="informes/resumen-cuenta" element={<ResumenCuentaVentas />} />
                  <Route path="informes/resumen-cuenta/:nroCliente" element={<ResumenCuentaVentas />} />
                  <Route path="informes/libro-iva-ventas" element={<LibroIvaVentas />} />
                  <Route path="informes/ventas-dinamico" element={<InformeVentasDinamico />} />
                  <Route path="informes/ventas-por-producto" element={<InformeVentasResumenProducto />} />
                  <Route path="informes/ventas-resultados" element={<InformeVentasResultados />} />
                  <Route path="informes/personalizados" element={<InformesPersonalizados />} />
                  <Route path="consultas-ia" element={<ConsultaIaModuloPage modulo="ventas" />} />
                </Route>
                <Route path="sistema">
                  <Route path="usuarios" element={<Usuarios />} />
                  <Route path="usuarios/nuevo" element={<UsuarioForm />} />
                  <Route path="usuarios/:usuario" element={<UsuarioForm />} />
                  <Route path="tipoformulario" element={<TipoFormulario />} />
                  <Route path="tipoformulario/nuevo" element={<TipoFormularioForm />} />
                  <Route path="tipoformulario/:nroTipoFormulario" element={<TipoFormularioForm />} />
                  <Route path="tipo-formulario" element={<TipoFormulario />} />
                  <Route path="tipo-formulario/nuevo" element={<TipoFormularioForm />} />
                  <Route path="tipo-formulario/:nroTipoFormulario" element={<TipoFormularioForm />} />
                  <Route path="provincias" element={<Provincias />} />
                  <Route path="provincias/nuevo" element={<ProvinciaForm />} />
                  <Route path="provincias/:codigoProvincia" element={<ProvinciaForm />} />
                  <Route path="localidades" element={<Localidades />} />
                  <Route path="localidades/nuevo" element={<LocalidadForm />} />
                  <Route path="localidades/:codLocalidad" element={<LocalidadForm />} />
                  <Route path="monedas" element={<Monedas />} />
                  <Route path="monedas/nuevo" element={<MonedaForm />} />
                  <Route path="monedas/:codigoMoneda" element={<MonedaForm />} />
                  <Route path="movmoneda" element={<MovMoneda />} />
                  <Route path="movmoneda/nuevo" element={<MovMonedaForm />} />
                  <Route path="movmoneda/:codigoMoneda/:fechaCotizacion" element={<MovMonedaForm />} />
                  <Route path="companias" element={<Companias />} />
                  <Route path="companias/nuevo" element={<CompaniaForm />} />
                  <Route path="companias/:idCompania" element={<CompaniaForm />} />
                  <Route path="certificados-arca" element={<CertificadosArca />} />
                  <Route path="wsfe-tipcomp" element={<WsfeTipComp />} />
                  <Route path="tenants" element={<TenantAdminGate><Tenants /></TenantAdminGate>} />
                  <Route path="tenants/nuevo" element={<TenantAdminGate><TenantForm /></TenantAdminGate>} />
                  <Route path="tenants/nuevo-desde" element={<TenantAdminGate><TenantCloneForm /></TenantAdminGate>} />
                  <Route path="tenants/:id/limpiar" element={<TenantAdminGate><TenantDataCleanup /></TenantAdminGate>} />
                  <Route path="tenants/:id" element={<TenantAdminGate><TenantForm /></TenantAdminGate>} />
                  <Route path="usuarios-maestros" element={<TenantAdminGate><MasterUsers /></TenantAdminGate>} />
                  <Route path="usuarios-maestros/nuevo" element={<TenantAdminGate><MasterUserForm /></TenantAdminGate>} />
                  <Route path="usuarios-maestros/:id" element={<TenantAdminGate><MasterUserForm /></TenantAdminGate>} />
                  <Route path="biblioteca-informes" element={<TenantAdminGate><BibliotecaInformes /></TenantAdminGate>} />
                  <Route path="biblioteca-informes/:id" element={<TenantAdminGate><BibliotecaInformeDetalle /></TenantAdminGate>} />
                  <Route path="caja-usuario" element={<CajaxUsuario />} />
                  <Route path="caja-usuario/nuevo" element={<CajaUsuarioForm />} />
                  <Route path="caja-usuario/:grupoMcp/:usuario" element={<CajaUsuarioForm />} />
                  <Route path="grupo-caja-usuario" element={<GrupoMcpUsuarioPage />} />
                  <Route path="grupo-caja-usuario/nuevo" element={<GrupoMcpUsuarioForm />} />
                </Route>
                <Route path="configuraciones">
                  <Route index element={<ConfiguracionesHub />} />
                  <Route path="transportes" element={<Transportes />} />
                  <Route path="transportes/nuevo" element={<TransporteForm />} />
                  <Route path="transportes/:nroExpreso" element={<TransporteForm />} />
                  <Route path="impuestos" element={<Impuestos />} />
                  <Route path="impuestos/nuevo" element={<ImpuestoForm />} />
                  <Route path="impuestos/:codigoImpuesto" element={<ImpuestoForm />} />
                  <Route path="ubicaciones" element={<Ubicaciones />} />
                  <Route path="ubicaciones/nuevo" element={<UbicacionForm />} />
                  <Route path="ubicaciones/:nroUbicacion" element={<UbicacionForm />} />
                  <Route path="sucventa" element={<SucVenta />} />
                  <Route path="sucventa/nuevo" element={<SucVentaForm />} />
                  <Route path="sucventa/:nroSuc/:nroTipoFormulario" element={<SucVentaForm />} />
                  <Route path="sucursalesventa" element={<SucursalesVenta />} />
                  <Route path="sucursalesventa/nuevo" element={<SucursalVentaForm />} />
                  <Route path="sucursalesventa/:nroSuc" element={<SucursalVentaForm />} />
                  <Route path="tokens-integracion" element={<IntegrationAccessTokens />} />
                  <Route path="claves-agente" element={<AgentAccessTokens />} />
                  <Route path="webhooks" element={<Webhooks />} />
                  <Route path="webhooks/ayuda" element={<WebhooksDocumentacion />} />
                  <Route path="correo-salida" element={<CorreoSalida />} />
                  <Route path="tienda" element={<ConfiguracionTienda />} />
                  <Route path="parametros" element={<ParametrosSistema />} />
                  <Route path="parametros/editar" element={<ParametroSistemaForm />} />
                  <Route path="variables-sistema" element={<VariablesSistema />} />
                  <Route path="variables-sistema/editar" element={<VariablesSistemaForm />} />
                  <Route path=":categoriaId" element={<ConfiguracionesHub />} />
                </Route>
                <Route path="contabilidad">
                  <Route index element={<ModuloFuncionalidades moduloPath="/contabilidad" cardScale={0.75} />} />
                  <Route path="asientos-diario" element={<AsientosDiario />} />
                  {/* Un solo segmento dinámico: "nuevo" o número; si /nuevo fuera ruta aparte, useParams().nroAsiento quedaría undefined y el formulario queda en loading eterno. */}
                  <Route path="asientos-diario/:nroAsiento" element={<AsientoDiarioForm />} />
                  <Route path="libro-mayor" element={<LibroMayor />} />
                  <Route path="informes" element={<ContabilidadInformes />} />
                  <Route path="informes/personalizados" element={<InformesPersonalizados />} />
                  <Route path="estado-resultados" element={<EstadoResultados />} />
                  <Route path="situacion-patrimonial" element={<SituacionPatrimonial />} />
                  <Route path="plan-cuentas" element={<PlanCuentas />} />
                  <Route path="imputables" element={<Imputables />} />
                  <Route path="imputables/nuevo" element={<ImputableForm />} />
                  <Route path="imputables/:codImputable" element={<ImputableForm />} />
                  <Route path="noimputables" element={<NoImputables />} />
                  <Route path="noimputables/nuevo" element={<NoImputableForm />} />
                  <Route path="noimputables/:nroRubro" element={<NoImputableForm />} />
                  <Route path="estrategia" element={<Estrategia />} />
                  <Route path="estrategia/nuevo" element={<EstrategiaForm />} />
                  <Route path="estrategia/:nint" element={<EstrategiaForm />} />
                </Route>
                <Route path="produccion">
                  <Route
                    index
                    element={
                      <ProduccionModuleGate>
                        <ModuloFuncionalidades moduloPath="/produccion" cardScale={0.75} />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="recetas"
                    element={
                      <ProduccionModuleGate>
                        <Recetas />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="recetas/nuevo"
                    element={
                      <ProduccionModuleGate>
                        <RecetaForm />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="recetas/:codigoReceta"
                    element={
                      <ProduccionModuleGate>
                        <RecetaForm />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="ordenes"
                    element={
                      <ProduccionModuleGate>
                        <OrdenesProduccion />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="ordenes/nuevo"
                    element={
                      <ProduccionModuleGate>
                        <OrdenProduccionForm />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="ordenes/:id"
                    element={
                      <ProduccionModuleGate>
                        <OrdenProduccionForm />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="ordenes/:id/confirmar"
                    element={
                      <ProduccionModuleGate>
                        <ConfirmarProduccion />
                      </ProduccionModuleGate>
                    }
                  />
                  <Route
                    path="ordenes/:id/desvios"
                    element={
                      <ProduccionModuleGate>
                        <DesviosConsumoProduccion />
                      </ProduccionModuleGate>
                    }
                  />
                </Route>
                <Route path="servicio">
                  <Route
                    index
                    element={
                      <ServicioModuleGate>
                        <ModuloFuncionalidades moduloPath="/servicio" cardScale={0.75} />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="tecnicos"
                    element={
                      <ServicioModuleGate>
                        <Tecnicos />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="tecnicos/nuevo"
                    element={
                      <ServicioModuleGate>
                        <TecnicoForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="tecnicos/:codigoTecnico"
                    element={
                      <ServicioModuleGate>
                        <TecnicoForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="vehiculos"
                    element={
                      <ServicioModuleGate>
                        <Vehiculos />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="vehiculos/nuevo"
                    element={
                      <ServicioModuleGate>
                        <VehiculoForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="vehiculos/:patente"
                    element={
                      <ServicioModuleGate>
                        <VehiculoForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="turnos"
                    element={
                      <ServicioModuleGate>
                        <Turnos />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="organizador"
                    element={
                      <ServicioModuleGate>
                        <OrganizadorServicios />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="ordenes-reparacion"
                    element={
                      <ServicioModuleGate>
                        <OrdenesReparacion />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="ordenes-reparacion/nuevo"
                    element={
                      <ServicioModuleGate>
                        <OrdenReparacionForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="ordenes-reparacion/:id"
                    element={
                      <ServicioModuleGate>
                        <OrdenReparacionForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="turnos/nuevo"
                    element={
                      <ServicioModuleGate>
                        <TurnoForm />
                      </ServicioModuleGate>
                    }
                  />
                  <Route
                    path="turnos/:id"
                    element={
                      <ServicioModuleGate>
                        <TurnoForm />
                      </ServicioModuleGate>
                    }
                  />
                </Route>
              </Route>
            </Routes>
            <PwaInstallPrompt />
            <AppUpdatePrompt />
          </Router>
          </PermissionProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App; 